import { useEffect, useLayoutEffect } from 'react';
export function useTermsScrollBoxEndSync(params) {
    const { scrollBoxRef, isOpen, termsHtml, termsDocumentUrl, linkedTerms, children, showIframeFallback, showLinkedLoading, updateScrollEndFromScrollBox, } = params;
    useLayoutEffect(() => {
        if (!isOpen) {
            return;
        }
        updateScrollEndFromScrollBox();
    }, [isOpen, termsHtml, termsDocumentUrl, linkedTerms, children, updateScrollEndFromScrollBox]);
    useEffect(() => {
        if (!isOpen || showIframeFallback || showLinkedLoading) {
            return;
        }
        const el = scrollBoxRef.current;
        if (!el || typeof ResizeObserver === 'undefined') {
            return;
        }
        const ro = new ResizeObserver(() => {
            updateScrollEndFromScrollBox();
        });
        ro.observe(el);
        return () => {
            ro.disconnect();
        };
    }, [isOpen, showIframeFallback, showLinkedLoading, scrollBoxRef, updateScrollEndFromScrollBox]);
}
